import { createDomainPagedAutoCompleteMetaData } from "commons/ultilities/dynamic-form/auto-complete/providers/schema-meta-data-helpers";
import { ObjectSchemaType } from "commons/ultilities/dynamic-form/hooks/use-form";
import { InputType } from "commons/ultilities/dynamic-form/models/control";
import { IAddProductGoodsIssue } from "mobx-stores/_models/product-inventory/product-goods-issue/product-goods-issue";

import { date, number, string } from "yup";

export const getAddProductGoodsIssueSchema =
  (): ObjectSchemaType<IAddProductGoodsIssue> => ({
    exportDate: {
      type: InputType.datePicker,
      gridSize: 12,
      label: "Ngày xuất",
      validattionYupSchema: date().required(),
    },
    items: {
      arraySchema: {
        productId: {
          type: InputType.autoComplete,
          gridSize: 12,
          label: "Sản phẩm",
          validattionYupSchema: string().required(),
          metaData: createDomainPagedAutoCompleteMetaData("product"),
          defaultValue: "",
        },
        quantity: {
          type: InputType.number,
          gridSize: 12,
          label: "Số lượng",
          validattionYupSchema: number().required(),
          defaultValue: 0,
        },
        note: {
          type: InputType.textArea,
          gridSize: 12,
          label: "Ghi chú",
          validattionYupSchema: string().max(1024),
          defaultValue: "",
        },
      },
    },
  });
